export const name = 'builderModuleLoader' as const

export const ReactTemplateSymbol = Symbol('ReactTemplateSymbol')
export const ESMLoaderFactorySymbol = Symbol('ESMLoaderFactorySymbol')
export const ESMLoadRegistrarSymbol = Symbol('ESMLoadRegistrarSymbol')
export const ImportMapSymbol = Symbol('ImportMapSymbol')
